<template>
  <div id="app">
    <span class="basisInformation">基础信息</span>
    <el-button class="baocun" type="primary" size="medium" @click="saveSchool"
      >保存修改</el-button
    >
    <el-divider></el-divider>
    <el-form label-width="150px" :model="schoolInformation" :rules="rulesForm">
      <el-form-item label="学校名称" prop="name">
        <el-input v-model.trim="schoolInformation.name" size="small"></el-input>
      </el-form-item>
      <el-form-item label="所属地区" prop="province">
        <!-- 省级 -->
        <el-select
          @change="changeProvince"
          placeholder="请选择"
          size="small"
          v-model="schoolInformation.province"
        >
          <el-option
            v-for="(item, index) in provincePlace"
            :key="index"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <!-- 市级 -->
        <el-select
          @change="changeCity"
          placeholder="请选择"
          size="small"
          v-model="schoolInformation.city"
        >
          <el-option
            v-for="(item, index) in cityPlace"
            :key="index"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
        <!-- 区级或县级 -->
        <el-select
          placeholder="请选择"
          size="small"
          v-model="schoolInformation.county"
        >
          <el-option
            v-for="(item, index) in countyPlace"
            :key="index"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学校标识码">
        <span>{{ schoolInformation.code }}</span>
      </el-form-item>
      <el-form-item label="校训" prop="schoolMotto">
        <el-input v-model="schoolInformation.schoolMotto" maxlength="28" show-word-limit  size="small" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="校风" prop="schoolSpirit">
        <el-input v-model="schoolInformation.schoolSpirit" maxlength="28" show-word-limit size="small" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model.trim="schoolInformation.address" size="small"></el-input>
      </el-form-item>
      <el-form-item label="学校级别" prop="areaLevel">
        <el-select
          @change="changeRegional"
          size="small"
          disabled
          v-model="schoolInformation.areaLevel"
        >
          <el-option label="省级" value="province"></el-option>
          <el-option label="市级" value="city"></el-option>
          <el-option label="区县级" value="county"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在单位" prop="provinceOrg">
        <!-- 省级 -->
        <el-select
          v-show="isprovince"
          placeholder="请选择"
          size="small"
          disabled
          v-model="schoolInformation.provinceOrg"
          @change="changeProvinceOrg"
        >
          <el-option
            v-for="(item, index) in provinceOrg"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- 市级 -->
        <el-select
          v-show="iscity"
          placeholder="请选择"
          size="small"
          disabled
          v-model="schoolInformation.cityOrg"
          @change="changecityOrg"
        >
          <el-option
            v-for="(item, index) in cityOrg"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- 区级或县级 -->
        <el-select
          v-show="iscounty"
          placeholder="请选择"
          disabled
          size="small"
          v-model="schoolInformation.countyOrg"
        >
          <el-option
            v-for="(item, index) in countyOrg"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="学校类型" prop="type">
        <el-radio-group v-model="schoolInformation.type">
          <el-radio
            v-for="(item, index) in schoolTypeList"
            :key="index"
            :label="item.code"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-form-item> -->
      <el-form-item class="fileimage" label="学校logo">
        <el-upload
          class="avatar-uploader"
          :show-file-list="false"
          :action="`${urlss}/file/oss-upload`"
          list-type="picture-card"
           :headers="headers"
          :on-success="successHandlerLogo"
        >
          <img :src="fileSchoolLogo" class="avatar" />
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span class="text">*需要上传175*50格式图片</span>
      </el-form-item>
      <el-form-item class="fileimage" label="工作台banner图">
        <el-upload
          class="avatar-uploader"
          :show-file-list="false"
          :action="`${urlss}/file/oss-upload`"
          :headers="headers"
          :on-success="successHandlerBanner"
        >
          <img :src="fileTopBanner" class="avatarimg" />
          <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
        </el-upload>
        <span class="text1">*需要上传1200*310格式图片</span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  schoolgetinfo,
  fileSever,
  areaList,
  fileUpload,
  orgList,
  getSchoolTypeList,
  postSchool,
  urls,
} from '@/api/home'
export default {
  data() {
    return {
      headers:{
        token:localStorage.getItem('token')
        },
      userId: 0,
      urlss: urls,
      schoolId: 0,
      schoolInformation: {},
      fileUrl: '',
      fileSchoolLogo: '',
      schoolLogo: '',
      fileTopBanner: '',
      topBanner: '',
      // 区域信息
      //   省级
      provincePlace: [],
      parentCode: 0,
      // 市级信息
      cityPlace: [],
      // 县级信息
      countyPlace: [],

      isprovince: true,
      iscity: true,
      iscounty: true,

      // 学校类型列表
      schoolTypeList: [],

      // 省级单位区域信息
      provinceOrg: [],
      //市级区域单位
      cityOrg: [],
      //县区级区域单位
      countyOrg: [],

      // 图片上传
      logoname: '',
      times: '',

      // 校验规则
      rulesForm: {
        name: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
        province: [
          { required: true, message: '请选择所属地区', trigger: 'change' },
        ],
        areaLevel: [
          { required: true, message: '请选择学校级别', trigger: 'change' },
        ],
        provinceOrg: [
          { required: true, message: '请选择所在单位', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择学校类型', trigger: 'change' },
        ],
        schoolMotto:[
          { required: true, message: '请输入校训', trigger: 'blur' }
        ],
        schoolSpirit:[
          { required: true, message: '请输入校风', trigger: 'blur' }
        ]
      },
    }
  },
  created() {
    this.userId = localStorage.getItem('schoolIds')
    this.schoolgetinfo()
    // 获取学校类型列表
    this.getSchoolTypeList()
    this.times = setInterval(() => {
      this.schoolId = localStorage.getItem('schoolIds')
      this.clearIntervals()
    }, 500)
  },
  watch: {
    // schoolLogo: function (val, oldVal) {
    //   this.fileSchoolLogo = this.fileUrl.concat(val);
    // },
    // topBanner: function (val, oldVal) {
    //   this.fileTopBanner = this.fileUrl.concat(val);
    // },
  },
  methods: {
    clearIntervals() {
      if (this.teacherId !== null) {
        clearInterval(this.times)
        this.schoolgetinfo()
      }
    },
    //   获取学校信息
    async schoolgetinfo() {
      this.userId = localStorage.getItem('schoolIds')
      try {
        const { data: res } = await schoolgetinfo({
          id: this.userId,
        })
        this.schoolInformation = res.data
        // 调用省级区域函数
        this.parentAreaList(res.data.province, res.data.city)
        // 省级区域单位
        this.parentOrgList(res.data.provinceOrg, res.data.cityOrg)
        // 初始渲染单位几级下拉框
        this.changeRegional(res.data.areaLevel)
        // 获取文件服务器地址
        this.fileSever()
        localStorage.setItem('schoolName', res.data.name)
      } catch (err) {
        console.log(err)
      }
    },

    // 获取文件服务器地址
    async fileSever() {
      try {
        const { data: res } = await fileSever({
          schoolId: this.schoolInformation.id,
        })
        this.fileUrl = res.data.serverHttp
        // 学校LOGO
        this.fileSchoolLogo = this.fileUrl.concat(
          this.schoolInformation.schoolLogo
        )
        // banner图
        this.fileTopBanner = this.fileUrl.concat(
          this.schoolInformation.topBanner
        )
        // 优化拼接logo
        this.fileImgLogo(this.schoolInformation.schoolLogo)
        // 优化拼接banner
        this.fileImgBanner(this.schoolInformation.topBanner)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取省级区域信息
    async parentAreaList(cityCode, countyCode) {
      try {
        const { data: res } = await areaList({
          parentCode: this.parentCode,
        })

        this.provincePlace = res.data
        this.cityAreaList(cityCode, countyCode)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取市级区域信息
    async cityAreaList(cityCode, countyCode) {
      try {
        const { data: res } = await areaList({
          parentCode: cityCode,
        })
        // 当市级数据为空时
        if (res.data.length == 0) {
          this.schoolInformation.city = ''
        }
        this.cityPlace = res.data
        this.countyAreaList(countyCode)
        var citys = this.cityPlace
      } catch (err) {
        console.log(err)
      }
      return citys
    },
    // 获取县级区域信息
    async countyAreaList(countyCode) {
      try {
        const { data: res } = await areaList({
          parentCode: countyCode,
        })
        // 当县级数据为空时
        if (res.data.length == 0) {
          this.schoolInformation.county = ''
          return false
        }
        this.countyPlace = res.data

        var countys = res.data
      } catch (err) {
        console.log(err)
      }
      return countys
    },

    // 省市县三级级联动
    // 省级变化
    changeProvince(ev) {
      const abc = this.cityAreaList(ev)
      let ab = abc.then((v) => {
        // 默认第一项
        this.schoolInformation.city = v[0].code
        // 调用县级函数
        const bc = this.countyAreaList(this.schoolInformation.city)
        let aa = bc.then((v) => {
          if (v.length == 0) {
            return false
          }
          this.schoolInformation.county = v[0].code
        })
      })
      // console.log("ab",ab);
    },
    // 市级变化
    changeCity(ev) {
      const city = this.countyAreaList(ev)
      let cityss = city.then((v) => {
        this.schoolInformation.county = v[0].code
      })
    },

    // 渲染单位几级下拉框
    changeRegional(ev) {
      if (ev == 'province') {
        this.isprovince = true
        this.iscity = false
        this.iscounty = false
      } else if (ev == 'city') {
        this.isprovince = true
        this.iscity = true
        this.iscounty = false
      } else {
        this.isprovince = true
        this.iscity = true
        this.iscounty = true
      }
    },

    //获取学校类型列表
    async getSchoolTypeList() {
      try {
        const { data: res } = await getSchoolTypeList()
        this.schoolTypeList = res.data
      } catch (err) {
        console.log(err)
      }
    },

    // 单位区域
    // 省级区域单位
    async parentOrgList(cityOrg, countyCode) {
      try {
        const { data: res } = await orgList({
          parentId: 0,
        })
        this.provinceOrg = res.data
        // 市级区域单位
        this.cityOrgList(cityOrg, countyCode)
      } catch (err) {
        console.log(err)
      }
    },

    // 市级区域单位
    async cityOrgList(cityOrg, countyCode) {
      try {
        const { data: res } = await orgList({
          parentId: cityOrg,
        })
        // 市级单位数据为空时
        if (res.data.length == 0) {
          this.schoolInformation.cityOrg = ''
          this.schoolInformation.countyOrg = ''
          return false
        }
        this.cityOrg = res.data
        this.countyOrgList(countyCode)
        var cityOrgs = res.data
      } catch (err) {
        console.log(err)
      }
      return cityOrgs
    },

    // 县区级单位
    async countyOrgList(countyCode) {
      if (!countyCode) {
        return false
      }
      try {
        const { data: res } = await orgList({
          parentId: countyCode,
        })
        // 县级数据为空时
        if (res.data.length == 0) {
          this.schoolInformation.countyOrg = ''
          return false
        }
        this.countyOrg = res.data
        var countyOrgs = res.data
      } catch (err) {
        console.log(err)
      }
      return countyOrgs
    },

    // 省市县单位三级联动

    // 省级单位变化
    changeProvinceOrg(ev) {
      const cityOrgss = this.cityOrgList(ev)
      let cityOrgsss = cityOrgss.then((ev) => {
        if (!ev) {
          return false
        }
        this.schoolInformation.cityOrg = ev[0].id
        const countyOrgss = this.countyOrgList(ev[0].id)
        let countyOrgsss = countyOrgss.then((ev) => {
          // if (ev.length == 0) {
          //   this.schoolInformation.countyOrg = ''
          //   return false
          // }
          this.schoolInformation.countyOrg = ev[0].id
        })
      })
    },
    // 市级单位变化
    changecityOrg(ev) {
      const countyOrgss = this.countyOrgList(ev)
      let countyOrgsss = countyOrgss.then((v) => {
        if (v.length == 0) {
          return false
        }
        this.schoolInformation.countyOrg = v[0].id
      })
    },
    // 学校Logo上传成功时
    successHandlerLogo(response, file, fileList) {
      // 保存图片到原始数据中
      this.schoolInformation.schoolLogo = response.data[0].fileName
      this.fileImgLogo(response.data[0].fileName)
    },
    // banner上传成功
    successHandlerBanner(response, file, fileList) {
      // 保存图片到原始数据中
      this.schoolInformation.topBanner = response.data[0].fileName
      this.fileImgBanner(response.data[0].fileName)
    },

    // 保证logo上传图片显示
    fileImgLogo(img) {
      this.fileSchoolLogo = this.fileUrl.concat(img)
    },
    // 保证banner上传显示
    fileImgBanner(img) {
      this.fileTopBanner = this.fileUrl.concat(img)
    },

    // 保存学校信息
    async saveSchool() {
      // console.log(this.schoolInformation);
      try {
        const res = await postSchool(this.schoolInformation)
      } catch (err) {
        console.log(err)
        this.$message.error({
          message: err.msg,
          type: 'success',
        })
      }
      this.$message({
        message: '保存成功',
        type: 'success',
      })
    },
  },
  mounted() {},
}
</script>
<style scoped>
#app {
  position: relative;
}

.basisInformation {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
}

.el-divider {
  margin-top: 18px;
  margin-bottom: 18px;
}

.baocun {
  position: absolute;
  right: 0;
  top: -10px;
}

.el-input {
  width: 290px;
}

.el-select {
  margin-right: 20px;
}

.fileimage {
  position: relative;
  margin-bottom: 40px;
}

.text {
  position: absolute;
  font-size: 12px;
  color: red;
  left: 10px;
  bottom: -35px;
}

.text1 {
  position: absolute;
  font-size: 12px;
  color: red;
  left: 10px;
  bottom: -20px;
}
</style>


// WEBPACK FOOTER //
// src/views/school/components/Info.vue